import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { immigrateCategoriesAPI } from 'features/immigrate-category/api'
import { immigrateFAQEntriesList } from './slice'
import { RequestUtils } from 'utils'

function* getList({ payload: { params } }) {
  try {
    let requestParams = {
      includes: ['questions'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(immigrateCategoriesAPI.getCategories, requestParams)

    const { data } = response

    const meta = data?.meta

    const { current_page, last_page } = meta ?? {}

    if (current_page && last_page && current_page > last_page) {
      yield put(
        immigrateFAQEntriesList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(immigrateFAQEntriesList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(immigrateFAQEntriesList.getListError(message))
  }
}

function* watchGetList() {
  yield takeLatest(immigrateFAQEntriesList.getList, getList)
}

export function* listSaga() {
  yield all([fork(watchGetList)])
}
